/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteConstraintCapacityDtoBase
 * auto generated base class for the model RouteConstraintCapacityDtoModel.
 */
export const RouteConstraintCapacityDtoModelBase = ModelBase
  .named('RouteConstraintCapacityDto')
  .props({
    __typename: types.optional(types.literal("RouteConstraintCapacityDto"), "RouteConstraintCapacityDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.string),
    value: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteConstraintCapacityDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
  get value() { return this.__attr(`value`) }
}
export function selectFromRouteConstraintCapacityDto() {
  return new RouteConstraintCapacityDtoModelSelector()
}

export const routeConstraintCapacityDtoModelPrimitives = selectFromRouteConstraintCapacityDto().name.value
